// Centralized dynamic loader for lunr to avoid static CommonJS import.
// Handles default interop when bundler wraps UMD build.
let _lunr: any = null;
export async function loadLunr(): Promise<any> {
  if (!_lunr) {
    const mod: any = await import('lunr');
    _lunr = mod.default ?? mod; // accommodate possible default wrapper
  }
  return _lunr;
}

export type LunrLike = Awaited<ReturnType<typeof loadLunr>>;
